import script from './component-lib.esm115.js';
import normalizeComponent from '../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('SvgIcon', _vm._g(_vm._b({
    attrs: {
      "viewBox": "0 0 20 20"
    }
  }, 'SvgIcon', Object.assign({}, _vm.$props, {
    title: _vm.$props.title || 'megaphone'
  }, _vm.$attrs), false), _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M17.223 7.030c-1.584-3.686-4.132-6.49-5.421-5.967-2.189 0.891 1.304 5.164-9.447 9.533-0.929 0.379-1.164 1.888-0.775 2.792 0.388 0.902 1.658 1.801 2.587 1.424 0.161-0.066 0.751-0.256 0.751-0.256 0.663 0.891 1.357 0.363 1.604 0.928 0.296 0.68 0.939 2.158 1.158 2.66s0.715 0.967 1.075 0.83c0.359-0.137 1.582-0.602 2.050-0.779s0.579-0.596 0.436-0.924c-0.154-0.355-0.786-0.459-0.967-0.873-0.18-0.412-0.769-1.738-0.938-2.156-0.23-0.568 0.259-1.031 0.97-1.104 4.894-0.512 5.809 2.512 7.475 1.834 1.287-0.525 1.025-4.259-0.558-7.942zM16.672 13.006c-0.287 0.115-2.213-1.402-3.443-4.267-1.231-2.863-1.076-5.48-0.79-5.597 0.286-0.115 2.165 1.717 3.395 4.58s1.124 5.167 0.838 5.284z"
    }
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var __vue_component__$1 = __vue_component__;
export { __vue_component__$1 as default };